import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {SiteDesignService} from "../../site-design/site-design.service";
import {exposeComponentInDebugMode} from "../../misc/expose-component-in-debug-mode.decorator";
import {toggleLoading} from "../../misc/loading.decorator";

export interface FixAccessoryDialogInputModel {
  assetId: string; // asset id to fix
  siteId: string; // site it's on
  serialNumber: string; // original serial number
}

@Component({
  templateUrl: "./fix-accessory-dialog.template.pug",
  providers: [
    SiteDesignService,
  ],
})
@exposeComponentInDebugMode()
export class FixAccessoryDialogComponent
  extends DialogComponent<FixAccessoryDialogInputModel, boolean>
  implements FixAccessoryDialogInputModel {
  error: Error;
  loading: boolean = false;

  assetId: string;
  siteId: string;

  serialNumber: string;

  rows: any[] = [];

  attachToDeployment: boolean = true;
  attachToOrder: boolean = true;

  static show(
    dialogService: DialogService,
    assetId: string,
    siteId: string,
    serialNumber: string,
  ): Promise<boolean> {
    return dialogService.showDialog(FixAccessoryDialogComponent, {assetId, siteId, serialNumber});
  }

  @toggleLoading()
  @handleErrors()
  async loadData() {
    this.rows = await this.siteDesignService.getAccessoryFixData(this.siteId, this.assetId, this.serialNumber);
  }

  @handleErrors()
  async assign(row?: any) {
    const destAssetId = `${(row ? row.id : "") || ""}`;

    this.result = await this.siteDesignService.fixAccessoryData(
      this.siteId,
      this.assetId,
      destAssetId,
      this.attachToOrder,
      this.attachToDeployment,
    );

    this.close();
  }

  ready() {
    this.loadData();
  }

  constructor(
    public dialogService: DialogService,
    public siteDesignService: SiteDesignService,
  ) {
    super(dialogService);
    this.result = false;
  }
}
